import React from "react";
import { Col, Row, Button } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";

import card from "../../assets/images/Home/CARD.svg";
// import first from "../../assets/images/Home/TopHeader/1.png";
// import second from "../../assets/images/Home/TopHeader/2.png";
// import third from "../../assets/images/Home/TopHeader/3.png";
// import mobile from "../../assets/images/Home/verticalmobile.png";

import HeaderImage from "../../assets/images/Home/slide_image.png";

const AddHeader = () => {
  return (
    <>
      <div className="add-header-component container" id="home">
        {/* <img
          src={HeaderImage}
          alt=""
          width={"100%"}
        // style={{ maxWidth: "936px" }}
        /> */}
        <Row>
          <Col className="head-data mt-5 mb-5" xs={12} md={12} lg={6}>
            <p className="speak-up">Remember every relationship. <span className="">Follow up at the right moment.</span></p>
            <p className="bottom-speak ">
              <span className=" fw-bold">Socius</span> is your AI-powered relationship hub for organizing people, notes, conversations, calls, and calendar moments in one private, intelligent place.
            </p>
            <div className="d-flex gap-3 mt-5 flex-wrap align-items-center">
              <Button 
                className="btn-theme-default px-4 py-3 fw-bold" 
                style={{ fontSize: "16px", borderRadius: "30px", minWidth: "180px" }}
                onClick={() => window.location.href = "#about-us"}
              >
                Download the App
              </Button>
              <Button 
                className="btn-theme-default px-4 py-3 fw-bold bg-transparent text-white" 
                style={{ fontSize: "16px", borderRadius: "30px", border: "2px solid #FF6F61", minWidth: "180px" }}
                onClick={() => window.location.href = "#feature"}
              >
                Explore Features
              </Button>
            </div>
            {/* <p className="mt-3 text-white fs-7" style={{ opacity: 0.8, fontSize: "14px" }}>
              Available for iOS and Android
            </p> */}
          </Col>
          {/* <Col
            className="ban-img d-none d-lg-block mt-5"
            md={{ span: 5, offset: 1 }}
          >
            <div className="vertical-img image-fluid"> */}
          {/* <img
                src={mobile}
                className="image-fluid vertical-image-css"
                alt=""
              /> */}
          {/* <div className="upper-image"> */}
          {/* <img src={card} className="upper-image-css" alt=""/> */}
          {/* </div>
            </div>
          </Col> */}
        </Row>
      </div>
    </>
  );
};
export { AddHeader };
